import { Avatar, Box, Checkbox } from '@mui/material';
import {
  GridColDef,
  GridRenderCellParams,
  GridTreeNodeWithRender,
} from '@mui/x-data-grid';
import React from 'react';
import { UseFormSetValue } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { AdminTeamContributionsService } from '../../app/admin/team-contributions/service';
import { getUserInitials } from '../functions/getUserInitials';
import { handleError } from '../functions/handleError';
import { ITeamContributions } from '../interfaces/team-contributions/ITeamContributions';

export const useEmployeeExpensesColumns = (
  setValue?: UseFormSetValue<ITeamContributions>,
): GridColDef[] => {
  const { t } = useTranslation();
  const { id } = useParams();

  return [
    { field: 'id', headerName: t('general.id'), width: 50 },
    {
      field: 'displayName',
      headerName: t('departments.employeeName'),
      flex: 1,
      renderCell: (
        params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>,
      ) => {
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Avatar
              style={{ marginRight: '8px' }}
              src={params.row?.profilePhoto?.thumbnail}
            >
              {getUserInitials(params.row)}
            </Avatar>
            {params.row?.displayName}
          </div>
        );
      },
    },

    {
      field: 'isFinishedContribution',
      headerName: t('general.isFinishedContribution'),
      width: 150,
      hideable: false,
      sortable: false,
      renderCell: (
        params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>,
      ) => {
        return (
          <Box>
            <Checkbox
              checked={params?.row?.isFinishedContribution}
              onClick={async () => {
                setValue &&
                  (await AdminTeamContributionsService.finish({
                    teamContributionId: Number(id),
                    isFinished: !params?.row?.isFinishedContribution,
                    userId: params?.row?.id,
                  })
                    .then((response) => {
                      setValue('users', response?.users);
                    })
                    .catch(handleError));
              }}
            />
          </Box>
        );
      },
    },
  ];
};
